// extracted by css-extract-rspack-plugin
export default {"root":"_1fe7wkuLD_XYJGznsPHwav","back":"OUTTiy3LvQtFcGALhmczn","actions":"_3lPbzFaP3m0iRmWb7GPifD","nav":"_1eLzvKJHQHRSH80494vnHC"};